import React from 'react';

import { locale } from '@trqk/utils';

import { IconX, IconInfoCircle } from '../../..';

export const ASCAPIntlPerformancesTooltip = ({
    close,
}: RenderTooltipMessageProps): JSX.Element => (
        <div className="text-tertiary-500 bg-white pb-4">
            <div className="flex justify-end px-2 pt-2">
                <IconX
                    width={12}
                    fillColor="tertiary-400"
                    handleClick={close}
                />
            </div>
            <div
                className="px-4 mt-2 grid"
                style={{
                    gridTemplateColumns: '34px auto',
                }}
            >
                <IconInfoCircle fillColor="quarternary-500" width={24} />
                <div>
                    {locale.enUS.STATEMENTS.KPIS.ASCAP_INTL_PERFORMANCES_INFO}
                </div>
            </div>
        </div>
    );
